import { render } from "./TopicManager.vue?vue&type=template&id=38a89f78&scoped=true"
import script from "./TopicManager.vue?vue&type=script&lang=js"
export * from "./TopicManager.vue?vue&type=script&lang=js"

import "./TopicManager.vue?vue&type=style&index=0&id=38a89f78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a89f78"]])

export default __exports__